"use strict";
function bannerCose() {
    document.querySelector('#banner_notification').style.display = 'none';
}
window.bannerCose = bannerCose;
